import _typeof from "@babel/runtime/helpers/typeof";
var DEFAULT_VALUE = true;
export var isSlidesLoopEnabled = function isSlidesLoopEnabled(slider) {
  var _slider$loop;
  if (_typeof(slider === null || slider === void 0 ? void 0 : slider.loop) === 'object') {
    return DEFAULT_VALUE;
  }
  return (_slider$loop = slider === null || slider === void 0 ? void 0 : slider.loop) !== null && _slider$loop !== void 0 ? _slider$loop : DEFAULT_VALUE;
};
//# sourceMappingURL=isSlidesLoopEnabled.js.map